<template>
  <section v-lenis-scroll class="the-380-banner">
    <div class="container" :class="{ loaded: isImageLoaded }">
      <div class="the-380-banner_image">
        <picture>
          <!-- Desktop WebP -->
          <source
            :srcset="shopifyData.heroImgDesktop.webp || shopifyData.heroImgDesktop.src"
            type="image/webp"
            media="(min-width: 1201px)"
          />
          <!-- Desktop JPEG -->
          <source
            :srcset="
              shopifyData.heroImgDesktop.src ||
              'https://cdn.shopify.com/s/files/1/1000/3130/files/behnologo.svg'
            "
            type="image/jpeg"
            media="(min-width: 1201px)"
          />
          <!-- Tablet WebP -->
          <source
            :srcset="
              shopifyData.heroImgTab?.webp ||
              shopifyData.heroImgTab?.src ||
              shopifyData.heroImgDesktop.src
            "
            type="image/webp"
            media="(min-width: 769px) and (max-width: 1200px)"
          />
          <!-- Tablet JPEG -->
          <source
            :srcset="
              shopifyData.heroImgTab?.src ||
              shopifyData.heroImgDesktop.src ||
              'https://cdn.shopify.com/s/files/1/1000/3130/files/behnologo.svg'
            "
            type="image/jpeg"
            media="(min-width: 769px) and (max-width: 1200px)"
          />
          <!-- Mobile WebP -->
          <source
            :srcset="
              shopifyData.heroImgMobile?.webp ||
              shopifyData.heroImgMobile?.src ||
              shopifyData.heroImgDesktop.src
            "
            type="image/webp"
            media="(max-width: 768px)"
          />
          <!-- Mobile JPEG -->
          <source
            :srcset="
              shopifyData.heroImgMobile?.src ||
              shopifyData.heroImgDesktop.src ||
              'https://cdn.shopify.com/s/files/1/1000/3130/files/behnologo.svg'
            "
            type="image/jpeg"
            media="(max-width: 768px)"
          />
          <!-- Fallback Image -->
          <img
            :src="
              shopifyData.heroImgDesktop.src ||
              'https://cdn.shopify.com/s/files/1/1000/3130/files/behnologo.svg'
            "
            :alt="shopifyData.heroImgDesktop.alt || 'Banner Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Banner Image"
            width=""
            height=""
            @load="onImageLoad"
            @error="onImageError"
          />
        </picture>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isImageLoaded: false,
    };
  },
  mounted() {
    //=========================================================//
    //=============== Load Image ==============================//
    // description:
    // this function is used to load the image from the shopify data and check if the image is loaded successfully
    // if the image is loaded successfully, the isImageLoaded variable is set to true
    // if the image is not loaded successfully, the isImageLoaded variable is set to false
    //=========================================================//

    if (this.shopifyData.heroImgDesktop?.src) {
      const img = new Image();
      img.src = this.shopifyData.heroImgDesktop.src;
      img.onload = () => {
        // console.log('Manual Load Success:', img.src);
        this.isImageLoaded = true;
      };
      img.onerror = () => {
        // console.error('Manual Load Failed:', img.src);
        this.isImageLoaded = true;
      };
    }

    //=========================================================//
    //=============== Upload File ==============================//
    // description:
    // this function is used to upload a file to the server
    // it is used to upload a file to the server
    // it is used to upload a file to the server
    // if the file is uploaded successfully, the fileNumber is returned
    // if the file is not uploaded successfully, the fileNumber is returned
    // if the file is not uploaded successfully, the fileNumber is returned
    //=========================================================//

    function uploadFile(fileNumber) {
      const size = Math.floor(Math.random() * 10) + 1;
      return new Promise((resolve, reject) => {
        // console.log(`Uploading file ${fileNumber} (size: ${size})...`);
        setTimeout(() => {
          if (size <= 5) {
            resolve(`✅ File ${fileNumber} uploaded successfully`);
          } else {
            reject(`❌ File ${fileNumber} too large, upload failed!`);
          }
        }, 2000);
      });
    }

    //=========================================================//
    //=============== Upload Files ============================//
    // description:
    // this function is used to upload all the files to the server
    // it is used to upload all the files to the server
    // it is used to upload all the files to the server
    // if the files are uploaded successfully, the result is returned
    // if the files are not uploaded successfully, the result is returned
    // if the files are not uploaded successfully, the result is returned
    //=========================================================//

    async function uploadAllFiles() {
      const files = [1, 2, 3, 4];
      const uploadPromises = files.map((fileNumber) => {
        // console.log(`Uploading file ${fileNumber}...`);
        return uploadFile(fileNumber);
      });
      const result = await Promise.allSettled(uploadPromises);
      // console.log(result);
      result.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          console.log(`File ${files[index]}: ${result.value}`);
        } else {
          console.log(`File ${files[index]}: ${result.value}`);
        }
      });
    }
    uploadAllFiles();
  },
  methods: {
    onImageLoad() {
      // console.log('Image Loaded Successfully:', event.target.currentSrc);
      this.isImageLoaded = true;
    },
    onImageError() {
      // console.error('Image Failed to Load:', event.target.src);
      this.isImageLoaded = true;
    },
  },
};
</script>

<style scoped>
.the-380-banner {
  position: relative;
  width: 100%;
  height: 100%;
}

.container {
  width: 100%;
  height: 100vh;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
}

.container.loaded {
  opacity: 1;
  height: 100%;
}

.the-380-banner_image {
  position: relative;
  width: 100%;
  height: 100%;
}

.the-380-banner_image picture,
.the-380-banner_image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
